import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { ColumnsType } from 'antd/es/table'
import renderDate from '../../../../helpers/tables/render-date'
import UserAudit from '../../../../types/api/components/audit/user-audit'
import Overtime from '../../../../types/api/overtime'

function getUserAuditUsername(userAudit?: UserAudit): string | undefined {
    if (!userAudit) return undefined

    return (
        userAudit.created_by_permissions_user?.username ||
        userAudit.updated_by_permissions_user?.username
    )
}

function renderUser(user?: UserAudit[]) {
    if (!user?.length) return null

    return user.map(getUserAuditUsername).filter(Boolean).join(', ')
}

interface GetColumnsParams {
    onDelete: (overtime: Overtime) => void
    isDeleting?: boolean
}

export const getColumns = ({
    onDelete,
    isDeleting,
}: GetColumnsParams): ColumnsType<Overtime> => [
    {
        title: 'Дата',
        dataIndex: 'date',
        width: 140,
        render: renderDate,
    },
    {
        title: 'Часы',
        dataIndex: 'hours',
        width: 100,
    },
    {
        title: 'Пользователь',
        dataIndex: 'user',
        render: renderUser,
    },
    {
        title: 'Действия',
        key: 'actions',
        width: 80,
        render: (_, record) => (
            <Popconfirm
                title='Удалить переработку?'
                okText='Удалить'
                cancelText='Отмена'
                onConfirm={() => onDelete(record)}
            >
                <Button size='small' danger icon={<DeleteOutlined />} loading={isDeleting} />
            </Popconfirm>
        ),
    },
]
